import '../components/stickyCTA/scripts';
import '../components/swiper/scripts';
import '../components/stickyFilters/scripts';
import '../components/connectedProducts/scripts';
import '../components/featuredCollectionCarousel/scripts';
import '../components/productSwatches/scripts';